import React from 'react';
import { generatePath, useHistory, useParams } from 'react-router-dom';
import propTypes from 'prop-types';
import AuthRoutes from '@/constants/routing/AuthRoutes';
import { DONOR_SECTION_CONFIGS } from '@/lib/configs/form-configs';
import translate from '@/lib/intl/translate';
import { ConstituentSectionTypes } from '@/propTypes';
import { ConstituentPropType } from '../configs/constituentTypes';
import ConstituentInformationCard from './ConstituentInformationCard';
import ConstituentSectionWrapper from './ConstituentSectionWrapper';

/**
 * This is a component for rendering donor sections
 * such as Personal Information and Company Information
 */
function ConstituentInformationSection({ data, isEditable, type }) {
  const history = useHistory();
  const { constituentId } = useParams();
  const { key, title, firstColConfig } = DONOR_SECTION_CONFIGS[type];

  const onEditClick = React.useCallback(
    () =>
      history.push(
        generatePath(AuthRoutes.CONSTITUENT_EDIT, { constituentId }),
      ),
    [constituentId, history],
  );
  return (
    <ConstituentSectionWrapper
      actionLabel={translate('EDIT')}
      id={key}
      isEditable={isEditable}
      onActionClick={onEditClick}
      title={title}
    >
      <ConstituentInformationCard
        data={data}
        firstColConfig={firstColConfig}
        isEditable={isEditable}
      />
    </ConstituentSectionWrapper>
  );
}

ConstituentInformationSection.propTypes = {
  data: ConstituentPropType,
  isEditable: propTypes.bool,
  type: propTypes.oneOf(Object.values(ConstituentSectionTypes)).isRequired,
};

ConstituentInformationSection.defaultProps = {
  data: {},
  isEditable: false,
};

export default ConstituentInformationSection;
